import React, { memo } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { setFilterMenuStatus, setEventTypeFilterDataArray, setEventTypeFilterId } from '../actions';
import { loadCourses } from '../../App/actions';
import CollapsedList from '../../../utils/Components/CollapsedList';
import FilterCollapse from './FilterCollapse';
import FilterOverlayBlock from '../../../utils/Components/FilterOverlayBlock';
import { FilterHeaderBlock } from '../FilterOverlay/FilterHeader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-light-svg-icons';
import LocalReset from '../../../utils/Components/LocalReset';
import CurrentFilterResetBlock from '../../../components/CurrentFilterResetBlock';
import { useInjectReducer } from '../../../utils/injectReducer';
import reducer from './reducer';
import { initialState } from '../reducer';
import { makeSelectEventTypeFilterMenuStatus } from './selectors';
import { toggleEventTypeFilterMenu } from './actions';
import Items from './Items';
import ShowResultsButton from '../../../utils/Components/ShowResultsButton';
import FilterListWrapper from '../../../utils/Components/FilterListWrapper';
import { EVENT_TYPE_FILTER_LABEL } from '../../../utils/site';

const key = 'eventType';

export function SearchEventType({
  eventTypeFilterMenuStatus,
  onToggleEventTypeFilterMenu,
  onSetEventTypeFilterDataArray,
  onSetEventTypeFilterId,
  onSetFilterMenuStatus,
}) {
  useInjectReducer({ key, reducer });

  const resetFilter = () => {
    onSetEventTypeFilterId(initialState.eventTypeFilterId);
    onSetEventTypeFilterDataArray(initialState.eventTypeFilterDataArray);
  };

  const handleResultsClick = () => {
    onToggleEventTypeFilterMenu(false);
    onSetFilterMenuStatus(false);
  };

  const CurrentFilterReset = () => (
    <LocalReset onClick={() => resetFilter()}>
      <CurrentFilterResetBlock />
    </LocalReset>
  );

  /**
   * Main return function.
   */
  return (
    <CollapsedList className={eventTypeFilterMenuStatus ? 'open' : ''}>
      <FilterCollapse />
      <FilterOverlayBlock className={'item-list'}>
        <FilterHeaderBlock>
          <span>{EVENT_TYPE_FILTER_LABEL.toUpperCase()}</span>
          <FontAwesomeIcon icon={faArrowLeft} onClick={() => onToggleEventTypeFilterMenu(false)} />
        </FilterHeaderBlock>
        <CurrentFilterReset />
        <FilterListWrapper>
          <Items />
        </FilterListWrapper>
        <ShowResultsButton onClick={() => handleResultsClick()}>Resultate anzeigen</ShowResultsButton>
      </FilterOverlayBlock>
    </CollapsedList>
  );
}

SearchEventType.propTypes = {
  eventTypeFilterMenuStatus: PropTypes.bool,
  onToggleEventTypeFilterMenu: PropTypes.func,
  onSetEventTypeFilterDataArray: PropTypes.func,
  onSetEventTypeFilterId: PropTypes.func,
  onSetFilterMenuStatus: PropTypes.func,
};

SearchEventType.defaultProps = {
  eventTypeFilterMenuStatus: false,
  onToggleEventTypeFilterMenu: () => {},
  onSetEventTypeFilterDataArray: () => {},
  onSetEventTypeFilterId: () => {},
  onSetFilterMenuStatus: () => {},
};

const mapStateToProps = createStructuredSelector({
  eventTypeFilterMenuStatus: makeSelectEventTypeFilterMenuStatus(),
});

export function mapDispatchToProps(dispatch) {
  return {
    onLoadCourses: () => dispatch(loadCourses()),
    onToggleEventTypeFilterMenu: (value) => dispatch(toggleEventTypeFilterMenu(value)),
    onSetEventTypeFilterDataArray: (value) => dispatch(setEventTypeFilterDataArray(value)),
    onSetEventTypeFilterId: (value) => dispatch(setEventTypeFilterId(value)),
    onSetFilterMenuStatus: (value) => dispatch(setFilterMenuStatus(value)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, memo)(SearchEventType);
